import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import InputField from "../components/InputField";
import HeaderComponent from "../components/HeaderComponent";
import Head from "../modules/Head";
import { Link } from "react-router-dom";
import "./RegistracijaPravnogLica.scss";
import "../components/FormValidationsWarning.scss";
import useTimeout from "../modules/useTimeout";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import config from "../config.json";

const RegistracijaPravnogLica = () => {
  const { baseUrl, token } = config;
  const [responseMessage, setResponseMessage] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);

  const onSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/register-pravnog-lica`,
        values,
        {
          headers: {
            token: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setResponseMessage(response.data.message);
      setIsRegistered(true);
      resetForm();
    } catch (error) {
      setResponseMessage(error.response.data.message);
    }
  };

  useTimeout(
    () => {
      if (isRegistered) {
        window.location.replace("/");
      }
    },
    3000,
    [isRegistered]
  );

  const {
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      ime: "",
      sjediste: "",
      telefon: "",
      IDBroj: "",
      djelatnost: "",
      email: "",
      korisnickoIme: "",
      password: "",
      passwordConfirm: "",
      logotip: "",
    },
    onSubmit,
    validationSchema: Yup.object({
      ime: Yup.string()
        .required("Niste unijeli ime.")
        .matches(
          /^[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*$/,
          "Ime ne može sadržavati brojeve."
        ),
      sjediste: Yup.string().required("Niste unijeli sjedište."),
      telefon: Yup.number()
        .typeError("Kontakt telefon mora biti broj.")
        .required("Niste unijeli kontakt telefon."),
      korisnickoIme: Yup.string()
        .required("Niste unijeli korisničko ime.")
        .matches(/^[A-Za-z]+$/, "Korisničko ime ne može sadržavati brojeve."),
      password: Yup.string()
        .required("Niste unijeli lozinku.")
        .min(8, "Lozinka mora sadržavati najmanje 8 znakova"),
      passwordConfirm: Yup.string()
        .required("Niste unijeli potvrdu lozinke.")
        .min(8, "Lozinka mora sadržavati najmanje 8 znakova")
        .oneOf([Yup.ref("password"), null], "Lozinke moraju biti iste"),
      IDBroj: Yup.string()
        .required("Niste unijeli ID broj.")
        .matches(/^[0-9]+$/, "ID broj mora biti broj.")
        .min(13, "ID broj mora sadržavati 13 brojeva")
        .max(13, "ID broj mora sadržavati 13 brojeva"),
      djelatnost: Yup.string()
        .required("Niste unijeli djelatnost.")
        .matches(
          /^[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*$/,
          "Djelatnost ne može sadržavati brojeve."
        ),
      email: Yup.string()
        .required("Niste unijeli e-mail adresu.")
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
          "Unijeli ste pogrešan format e-mail adrese"
        ),
    }),
  });

  return (
    <>
      <Head title="Registracija pravnog lica" />
      <Container fluid="md" className="registracija-pravnog-lica-container">
        <HeaderComponent title="Registracija pravnog lica" />

        <Form onSubmit={handleSubmit}>
          <Row className="form-container">
            <Col md={6} className="registracija-pravnog-lica">
              <InputField
                label="Ime pravnog lica"
                type="text"
                id="ime"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.ime}
              />
              {touched.ime && errors.ime ? (
                <span className="input-error">{errors.ime}</span>
              ) : null}

              <InputField
                label="Sjedište"
                type="text"
                id="sjediste"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.sjediste}
              />
              {touched.sjediste && errors.sjediste ? (
                <span className="input-error">{errors.sjediste}</span>
              ) : null}

              <InputField
                label="Kontakt telefon"
                type="text"
                id="telefon"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.telefon}
              />
              {touched.telefon && errors.telefon ? (
                <span className="input-error">{errors.telefon}</span>
              ) : null}
              <InputField
                label="Uploadujte logotip u dimenziji 160x160px"
                type="file"
                id="logotip"
                accept="image/*"
                onChange={(e) => setFieldValue("logotip", e.target.files[0])}
                onBlur={handleBlur}
              />
            </Col>

            <Col md={6} className="registracija-pravnog-lica">
              <InputField
                label="ID broj"
                type="text"
                id="IDBroj"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.IDBroj}
              />
              {touched.IDBroj && errors.IDBroj ? (
                <span className="input-error">{errors.IDBroj}</span>
              ) : null}
              <InputField
                label="Djelatnost"
                type="text"
                id="djelatnost"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.djelatnost}
              />
              {touched.djelatnost && errors.djelatnost ? (
                <span className="input-error">{errors.djelatnost}</span>
              ) : null}
              <InputField
                label="Kontakt email"
                type="text"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
              />
              {touched.email && errors.email ? (
                <span className="input-error">{errors.email}</span>
              ) : null}

              <InputField
                label="Lozinka"
                type="password"
                id="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
              {touched.password && errors.password ? (
                <span className="input-error">{errors.password}</span>
              ) : null}
            </Col>
            <Col md={12}></Col>
            <Col md={6} className="registracija-pravnog-lica">
              <InputField
                label="Korisničko ime"
                type="text"
                id="korisnickoIme"
                name="korisnickoIme"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.korisnickoIme}
              />
              {touched.korisnickoIme && errors.korisnickoIme ? (
                <span className="input-error">{errors.korisnickoIme}</span>
              ) : null}
            </Col>
            <Col md={6} className="registracija-pravnog-lica">
              <InputField
                label="Potvrda lozinke"
                type="password"
                id="passwordConfirm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.passwordConfirm}
              />
              {touched.passwordConfirm && errors.passwordConfirm ? (
                <span className="input-error">{errors.passwordConfirm}</span>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col className="buttons">
              <Button
                type="submit"
                id="primary"
                className="btn btn-success registracija-btn"
              >
                OK
              </Button>
              <Link to="/">
                <Button
                  className="btn btn-danger registracija-btn"
                  id="danger"
                >
                  ODUSTAJEM
                </Button>
              </Link>
            </Col>
          </Row>
        </Form>
        <br></br>
        <b>{responseMessage}</b>
      </Container>
    </>
  );
};

export default RegistracijaPravnogLica;
